
import { Component, Prop, Vue } from "vue-property-decorator";
import {CustomsPackingSummation, ProductStatistics, ProductSummation} from "@/model/HqPackingListModels";

@Component({
  name: "CustomsPackingStatistics"
})

export default class extends Vue {

  @Prop({ required: false }) productSummation: ProductSummation;
  @Prop({ required: false }) customsPackingSummation: CustomsPackingSummation;
}


